import { render } from "./SubmissionsPanel.vue?vue&type=template&id=2c6e3a18&scoped=true"
import script from "./SubmissionsPanel.vue?vue&type=script&lang=js"
export * from "./SubmissionsPanel.vue?vue&type=script&lang=js"

import "@/Common/Styles/submissionsPanel.scss?vue&type=style&index=0&id=2c6e3a18&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6e3a18"]])

export default __exports__